module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAIlJREFUeNqUUTEOgCAMPBh5HiwmuPAyJxMXfJ6DS20BE0Ex4ZKD0l4pLYqsnQEciHHHH5yzvBqdxMDGDv8j9kkjWiICV/HMM+1yfrKJdQM9n0pZdemFGYon2zGut6ROqJPQigUag9Cd20Ph8preaNPDY1Vs2PIprwY/njpJD0aMrliQY5NoLwEGANaVpn06Dgd6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/valid-no.png
// module id = 1532
// module chunks = 0